import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { TooltipContainerText } from "./components/tooltip-container.es.js";
import MUITooltip from "../../../node_modules/@mui/material/Tooltip/Tooltip.es.js";
function Tooltip({
  children,
  title,
  description,
  ...rest
}) {
  return /* @__PURE__ */ jsx(MUITooltip, { title: /* @__PURE__ */ jsx(TooltipContainerText, { title, description }), ...rest, children });
}
export {
  Tooltip
};
//# sourceMappingURL=tooltip.es.js.map
